import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Grid, Paper, Popover } from "@material-ui/core";
import Typography from "@components/Typography";
import clsx from "clsx";
import Button from "@components/Button";
import user from "@api/user";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

const FeePopover = ({ alignment, handleAlignment }) => {
  const classes = useStyles();
  const [state, setState] = useState({
    open: false,
    anchorEl: false,
    data: [],
    isFetched: false,
  });

  useEffect(() => {
    user
      .getUserLimitationsInfo()
      .then((data) => {
        setState((prevState) => ({
          data: data.content,
          isFetched: true,
        }));
      })
      .catch((data) => {});
  }, []);

  const handleOpen = (event) => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      anchorEl: event.target,
    }));
  };
  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      open: null,
      anchorEl: null,
    }));
  };

  return (
    <Grid container justify="space-between" className={classes.container}>
      <Grid item>
        <ToggleButtonGroup
          className={classes.switchBtn}
          value={alignment}
          exclusive
          onChange={handleAlignment}
        >
          <ToggleButton title={__t("Limit Order")} value="Limit_Order">
            {__t("Limit Order")}
          </ToggleButton>

          <ToggleButton
            title={__t("Current Market Price")}
            value="Current_Market_Price"
          >
            {__t("Current Market Price")}
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid item>
        <div className={classes.extraTextContainer}>
          <Typography variant="3xs" color="teal.main">
            {__t("How do I trade?")}
          </Typography>
          <div
            onClick={handleOpen}
            className={clsx(
              state.open ? "icon-x" : "icon-more-vertical",
              classes.icon
            )}
          />
        </div>
        {state.open && (
          <Popover
            open={state.open}
            anchorEl={state.anchorEl}
            onClose={handleClose}
            className={classes.popOverContainer}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Paper className={classes.popOver} elevation={0}>
              <Grid
                container
                direction="column"
                justify="space-between"
                spacing={10}
              >
                <Grid item container direction="row" justify="space-between">
                  <Grid item>
                    <Typography color="secondary.tint15" variant="2xs">
                      {__t("Transaction Fee At Your User Level:")}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="2xs">%</Typography>
                    <Typography isBold variant="2xs">
                      {state.isFetched ? state.data.tradeFee : 0.35}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="default"
                    size="small"
                    endIcon={<span className="icon-chevron-left" />}
                  >
                    <Typography variant="2xs">{__t("Fees")}</Typography>
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Popover>
        )}
      </Grid>
    </Grid>
  );
};

export default FeePopover;
